import React, { Component, Fragment } from 'react';
import './Home.css';
import icon1 from '../../image/icon1.svg'
import icon2 from '../../image/icon2.svg'
import icon3 from '../../image/icon3.svg'
import logoblue from '../../image/logoblue.png'
import phone from '../../image/phone.png'
import N1 from '../../image/1.svg'
import N2 from '../../image/2.svg'
import N3 from '../../image/3.svg'
import imageContent from '../../image/image-content.png'
import icon4 from '../../image/icon4.svg'
import icon5 from '../../image/icon5.svg'
import icon6 from '../../image/icon6.svg'
import icon7 from '../../image/icon7.svg'
import Oval from '../../image/Oval.png'
import star from '../../image/star.svg'
import Frame from '../../image/Frame.svg'

import { Link } from 'react-router-dom';

import ScrollableAnchor from 'react-scrollable-anchor'
import Footer from '../Components/Footer/Footer'

class Home extends Component {
   
    handelHideNav = ()=>{
    if(window.screen.width<992 ){
        const btnNav = document.getElementById('btnNav');
    btnNav.click();
    }

}
    render() {
        window.addEventListener('scroll', function (e) {
            if (document.getElementById('nav')) {
                var nav = document.getElementById('nav');
                if (document.documentElement.scrollTop || document.body.scrollTop > window.innerHeight) {
                    nav.classList.add('colornav');
                    nav.classList.remove('colornav2');
                } else {
                    nav.classList.add('colornav2');
                    nav.classList.remove('colornav');
                }
            }
        });
        document.title ="Kayn"; 
        document.getElementsByTagName("META")[1].content="We pick, store, pack, ship and collect your money. This allow you to focus on what really matters: multiply your e-commerce sales, earn more money and enjoy your free time getting your things done by our Kayn team!";
            document.documentElement.lang = 'en';
        return (
            <div className=" AppEN home">

                <header>
                    <div className='container'>
                        <nav className="navbar navbar-expand-lg color-md fixed-top  colornav2" id="nav">
                            <div className="container">
                                <Link to="/"><img className="logo" src={logoblue} alt="Kayn" /></Link>
                                <button className="navbar-toggler navbar-dark " id="btnNav" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarNav">
                                    <ul className="navbar-nav ml-auto text-uppercase">
                                        <li className="nav-item active">
                                            <a className="nav-link" href="/#Feautures" onClick={this.handelHideNav}>Feautures<span className="sr-only">(current)</span></a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" href="/#Howitwork" onClick={this.handelHideNav}>How it work</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" href="/#Reviews" onClick={this.handelHideNav}>Reviews</a>
                                        </li>
                                        {(localStorage.getItem("userToken") ?
                                            <Fragment>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/Orders">Orders</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to={"/AR" + window.location.pathname} >AR</Link>
                                                </li>
                                            </Fragment>
                                            : (localStorage.getItem("AdminTokenKayn") ?
                                                <Fragment>
                                                    <li className="nav-item">
                                                        <Link className="nav-link" to="/Admin/Orders">Orders</Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link className="nav-link" to={"/AR" + window.location.pathname} >AR</Link>
                                                    </li>
                                                </Fragment>
                                                :
                                                <Fragment>
                                                    <li className="nav-item">
                                                        <Link className="nav-link" to="/SignUp">SignUp</Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link className="nav-link" to="/SignIn">SignIn</Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Link className="nav-link" to={"/AR" + window.location.pathname} >AR</Link>
                                                    </li>
                                                </Fragment>))}
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        <div className="row mx-0">
                            <div className="col-lg-6 contant  ">
                                <h3 className="fontsize3 my-3 ">Start selling three times more with us today!</h3>
                                <p className="fontsize5 my-3 ">Triple your e-commerce orders by automating your shipping with our most advanced shipping app in Egypt.</p>
                                <Link to="/Signup" className="btn btn-light badge-pill my-3 p-3 px-5 border shadow  text-muted btnhome"  >SIGN UP</Link>
                            </div>
                        </div>
                    </div>
                </header>
                <ScrollableAnchor id="Feautures">
                    <section className="feautures container"   >
                        <div className="row mx-0  py-5">
                            <div className="col-md-4 text-center">
                                <div className="p-3 my-5 mx-3">
                                    <img className="my-3" src={icon1} alt="feautures kayn" />
                                    <div>
                                        <h3 className="fontsize4 my-2">Multiply your earnings</h3>
                                        <p className="text-muted my-2">We pick, store, pack, ship and collect your money. This allow you to focus on what really matters.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4  text-center">
                                <div className="p-3 my-5 mx-3">
                                    <img className="my-3" src={icon2} alt="feautures kayn" />
                                    <div>
                                        <h3 className="fontsize4 my-2">Save time and headache</h3>
                                        <p className="text-muted my-2">We pick, store, pack, ship and collect your money. This allow you to focus on what really matters.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4  text-center">
                                <div className="p-3 my-5 mx-3">
                                    <img className="my-3" src={icon3} alt="feautures kaynvvv" />
                                    <div>
                                        <h3 className="fontsize4 my-2">Monitor your progress</h3>
                                        <p className="text-muted my-2">We pick, store, pack, ship and collect your money. This allow you to focus on what really matters.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section >
                </ScrollableAnchor>
                <section className="py-4">
                    <div className="container">
                        <div className="feauturesPick px-2">
                            <div className=" col-lg-7 mx-auto text-center">
                                <h2 className="fontsize7">80% of your sales will come from 20% of your efforts </h2>
                                <p className="text-muted my-2">
                                    We pick, store, pack, ship and collect your money. This allow you to focus on what really matters: multiply your e-commerce sales, earn more money and enjoy your free time getting your things done by our Kayn team!
                                    </p>
                            </div>
                            <div className="row mx-0 ">
                                <div className="col-lg-5 py-5 mt-3 px-0">
                                    <div className="row mx-0 my-4">
                                        <div className="col-3 mt-4 text-center">
                                            <img className="" src={N1} alt="1" />
                                        </div>
                                        <div className="col-9 pr-0 pl-4">
                                            <h5 className=" my-3">Schedule your pick up</h5>
                                            <p className="text-muted my-2">Schedule it easy in our Kayn app and we gladly arrive to your doorsteps to collect the pickup. </p>
                                        </div>
                                    </div>
                                    <div className="row mx-0 my-4">
                                        <div className="col-3 mt-4 text-center">
                                            <img className="" src={N2} alt="2" />
                                        </div>
                                        <div className="col-9 pr-0 pl-4">
                                            <h5 className=" my-3">Monitor your delivery</h5>
                                            <p className="text-muted my-2">Our advanced tracking system let you monitor your product delivery in real time on each step of courier route. </p>
                                        </div>
                                    </div>
                                    <div className="row mx-0 my-4">
                                        <div className="col-3 mt-4 text-center">
                                            <img className="" src={N3} alt="3" />
                                        </div>
                                        <div className="col-9 pr-0 pl-4">
                                            <h5 className=" my-3">Easy get payed</h5>
                                            <p className="text-muted my-2">We collect any payment for your sold items for you and deposit directly to your wallet. Pay off whenever you wish. </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-7 pl-0 phone">
                                    <img className="mt-3 w-100" src={phone} alt="Kayn phone" />
                                </div>
                            </div>
                            <div className="moneyPick">
                                <div className="row">
                                    <div className="col-md-6 text-center imageContent">
                                        <img className="" src={imageContent} alt="imageContent" />

                                    </div>
                                    <div className="col-lg-5 py-md-4 ">
                                        <h3 className="fontsize7 my-4">Never miss a sale,<br />Get always step ahead.</h3>
                                        <p className="text-muted my-2">We pick, store, pack, ship and collect your money.
                                            This allow you to focus on what really matters: multiply your e-commerce sales, earn more money and enjoy your free time getting your things done by our Kayn team!</p>
                                        <div className="row mx-0 text-center my-md-5 " >
                                            <div className="col-4">
                                                <p className="fontsize8 mb-0">10k</p>
                                                <h6 className="mx-2">Downloads</h6>
                                            </div>
                                            <div className="col-4 p-0">
                                                <p className="fontsize8 mb-0">30k</p>
                                                <h6 className="mx-2">Positive Reviews</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
                </section>
                <ScrollableAnchor id="Howitwork">

                    <section className="py-5 container" >
                        <div className="howitwork py-5" >
                            <div className="text-center col-md-8 mx-auto ">
                                <h2 className="fontsize7 ">How Kayn works?</h2>
                                <p className="text-muted my-2" >Our users are impatient. They're probably distracted too. Keep it simple and beautiful, fun and functional. Clean aesthetics supported by a strong concept is what we stand for.</p>
                            </div>
                            <div className="row mx-0 py-5">
                                <div className="col-md-3 mx-2 px-0">
                                    <div className=" text-center">
                                        <img className="my-3" src={icon6} alt="Monitor your progress" />
                                        <div>
                                            <h3 className="fontsize4 my-2">Monitor your progress</h3>
                                            <p className="text-muted my-2">We pick, store, pack, ship and collect your money. This allow you to focus on what really matters.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1  icon my-5 text-center p-0">
                                    <img className="my-3" src={icon7} alt="arrow" />
                                </div>
                                <div className="col-md-3 mx-2 px-0">
                                    <div className=" text-center">
                                        <img className="my-3" src={icon4} alt="Monitor your progress" />
                                        <div>
                                            <h3 className="fontsize4 my-2">Monitor your progress</h3>
                                            <p className="text-muted my-2">We pick, store, pack, ship and collect your money. This allow you to focus on what really matters.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1 icon my-5 text-center p-0">
                                    <img className="my-3" src={icon7} alt="arrow" />
                                </div><div className="col-md-3 mx-2 px-0">
                                    <div className=" text-center">
                                        <img className="my-3" src={icon5} alt="Monitor your progress" />
                                        <div>
                                            <h3 className="fontsize4 my-2">Monitor your progress</h3>
                                            <p className="text-muted my-2">We pick, store, pack, ship and collect your money. This allow you to focus on what really matters.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                </ScrollableAnchor>
                <ScrollableAnchor id="Reviews">
                    <section className=" reviews py-5" >
                        <div className="container py-3">
                            <div className="col-md-7 text-center text-white mx-auto ">
                                <h2 className="fontsize7 my-3"> How clients love our service</h2>
                                <p className="text-light">Our users are impatient. They're probably distracted too. Keep it simple and fast, fun and functional. Clean aesthetics supported by a strong concept is what we stand for.</p>
                            </div>
                            <div className="col-md-6 mx-auto text-white py-4">
                                <div id="carouselExampleInterval" className="carousel slide" data-ride="carousel">
                                    <div className="carousel-inner my-3">
                                        <div className="carousel-item active" data-interval="10000">
                                            <div className="row">
                                                <div className="col-md-1 text-center">
                                                    <img className="my-3" src={Oval} alt="user" />
                                                </div>
                                                <div className="col-md-10 m-3">
                                                    <p className="font-italic">You made it so simple. My shipping is so much faster and easier to deliver product to my customers. I just create order and they take care about everything else. Thanks, guys!</p>
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <p className="font-weight-bold my-3">Abdullah Ibn Ali</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-1 text-center">
                                                    <img className="my-3" src={Oval} alt="user" />
                                                </div>
                                                <div className="col-md-10 m-3">
                                                    <p className="font-italic">You made it so simple. My shipping is so much faster and easier to deliver product to my customers. I just create order and they take care about everything else. Thanks, guys!</p>
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <p className="font-weight-bold my-3">Abdullah Ibn Ali</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="carousel-item" data-interval="2000">

                                            <div className="row">
                                                <div className="col-md-1 text-center">
                                                    <img className="my-3" src={Oval} alt="user" />
                                                </div>
                                                <div className="col-md-10 m-3">
                                                    <p className="font-italic">You made it so simple. My shipping is so much faster and easier to deliver product to my customers. I just create order and they take care about everything else. Thanks, guys!</p>
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <p className="font-weight-bold my-3">Halif Barun</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-1 text-center">
                                                    <img className="my-3" src={Oval} alt="Oval" />
                                                </div>
                                                <div className="col-md-10 m-3">
                                                    <p className="font-italic">You made it so simple. My shipping is so much faster and easier to deliver product to my customers. I just create order and they take care about everything else. Thanks, guys!</p>
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <img className="" src={star} alt="star" />
                                                    <p className="font-weight-bold my-3">Halif Barun</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <ol className="carousel-indicators ">
                                        <li data-target="#carouselExampleInterval" data-slide-to="0" className="active"></li>
                                        <li data-target="#carouselExampleInterval" data-slide-to="1"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollableAnchor>

              
                <section className="applynow   py-5">
                    <div className="container">
                        <div className="row mx-0 py-5">
                            <div className="col-md-6 text-center Frame">
                                <img className="my-5" src={Frame} alt="Frame" />
                            </div>
                            <div className="col-lg-6  p-5 ">
                                <h2 className="fontsize7 text-white  my-5">Do you have a vehicle and need an extra cash?</h2>
                                <p className="text-white my-5">Apply easy filling our form to become part of Halpyl!</p>
                                <Link to="/Courier/Signup" className="btn btn-light badge-pill my-3 p-3 px-lg-5 border shadow  text-muted btnhome">APPLY NOW </Link>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="installapp  py-5">
                    <div className="container ">
                        <div className="col-lg-6  text-center">
                            <h2 className="fontsize7   my-5">Try Kayn for free!</h2>
                            <p className="text-muted my-4">Big, small, online, offline, local or international business. Size doesn't matter. We work on diverse projects for top brands as well as for cool startups</p>
                            <p className="text-muted my-4">We pick, store, pack, ship and collect your money. This allow you to focus on what really matters: multiply your e-commerce sales, earn more money and enjoy your free time getting your things done by our Kayn team!</p>

                            <Link to="/Signup" className="btn btn-light badge-pill my-3 p-3 px-5 border shadow  text-muted btnhome">SignUp</Link>
                        </div>
                    </div>
                </section><hr className="m-0"/>
                <Footer/>
        </div >

        )
    }
}
export default Home;